import React, { memo } from "react";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import "./ChipRenderer.js";
import { ChipVariant, ChipType } from "./types.js";
import { Chip } from "./Chips.js";
import "./ListWithChipTooltip.js";
import "../icons/Icon.js";
import "../icons/ExpandMoreIcon.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { dashCharacter } from "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
import { StyledTooltip } from "../tooltip/Tooltip.js";
import "moment-timezone";
import "react-intl";
import "../tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../tooltip/MultiLineAutoAdjustedWidthTooltip.js";
const useClasses = makeStyles()((theme) => ({
  flexArrayContainer: {
    display: "flex",
    flexWrap: "nowrap",
    overflow: "hidden",
    alignItems: "center",
    "& :nth-child(1)": {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis"
    },
    "& span:nth-child(n+2)": {
      "&::before": {
        content: '", "'
      }
    }
  },
  valueContainer: {
    display: "block",
    marginLeft: theme.spacing(1),
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
  },
  chipListContainer: {
    display: "flex",
    width: "100%",
    alignItems: "center"
  },
  chipListLabel: {
    lineHeight: theme.typography.body1.lineHeight,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "200px"
  },
  chipListTooltip: {
    whiteSpace: "pre"
  },
  chipListMore: {
    marginLeft: "auto"
  }
}));
const ValueChip = ({ label, value, variant, type, children }) => {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement(Box, { className: classes.flexArrayContainer, "data-testid": "chipListLabel" }, /* @__PURE__ */ React.createElement(Chip, { fillWidth: false, chipType: type, chipVariant: variant, label, value }), /* @__PURE__ */ React.createElement(Box, { display: "flex", className: classes.valueContainer }, children));
};
const SquaredChipList = ({ list, hideTooltip, label }) => {
  const { classes } = useClasses();
  const totalItems = list?.length;
  const chipKey = totalItems ? /* @__PURE__ */ React.createElement(LocalizedText, { label: label ?? list[0].key }) : dashCharacter;
  const chipValue = totalItems ? /* @__PURE__ */ React.createElement(LocalizedText, { label: list[0].value }) : dashCharacter;
  const getTooltipValue = (val) => {
    return val ? `: ${val}` : "";
  };
  const tooltip = list?.map((l) => `${l.key} ${getTooltipValue(l.value)}`).join("\r\n");
  return /* @__PURE__ */ React.createElement(
    StyledTooltip,
    {
      element: /* @__PURE__ */ React.createElement(Box, { className: classes.chipListContainer }, !totalItems ? /* @__PURE__ */ React.createElement(Box, { className: classes.chipListLabel, "data-testid": "chipListLabel" }, dashCharacter) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ValueChip, { type: ChipType.Prefix, variant: ChipVariant.Default, label: chipKey, value: totalItems }, chipValue))),
      title: /* @__PURE__ */ React.createElement(Box, { className: classes.chipListTooltip }, tooltip),
      hideTooltip
    }
  );
};
const SquaredChipList_default = memo(SquaredChipList);
export {
  ValueChip,
  SquaredChipList_default as default
};
//# sourceMappingURL=SquaredChipList.js.map
